import React from 'react';
import { BadgeCheckIcon, StarIcon } from 'lucide-react';
import { SectionHeading } from '../SectionHeading';
import { SectionCTA } from '../SectionCTA';
import { testimonials } from '../../data/content';
export function Testimonials() {
  return <section className="w-full bg-mist px-4 py-14 sm:py-20" aria-labelledby="testi-title" data-id="element-304" data-mp="3mepjurjhftqe">
      <div className="mx-auto max-w-5xl" data-id="element-305" data-mp="3r8trld0ko5sj">
        <SectionHeading id="testi-title" lead="Clinicians who now run a structured post-laser assessment workflow." data-id="element-306" data-mp="1hizmdr90o8">
          What professionals are <span className="text-accent-600" data-id="element-307" data-mp="41i2hlfpo225">saying</span>
        </SectionHeading>

        <div className="mt-10 grid gap-5 md:grid-cols-2" data-id="element-308" data-mp="92xk13iojqfs">
          {testimonials.map(t => <figure key={t.name} className="flex flex-col rounded-3xl bg-white p-6 ring-1 ring-navy-900/10" data-id="element-309" data-mp="dzxqvgncsx7y">
              <div className="flex gap-0.5" aria-label="5 out of 5 stars" data-id="element-310" data-mp="2aukexg5p05hj">
                {Array.from({
              length: 5
            }).map((_, i) => <StarIcon key={i} className="h-5 w-5 fill-gold-400 text-gold-400" aria-hidden="true" data-id="element-311" data-mp="2fu6sxrtchpre" data-mpi={i} />)}
              </div>
              <blockquote className="mt-4 flex-1 text-base leading-relaxed text-ink/85 sm:text-[17px]" data-id="element-312" data-mp="1ntkjj0dp9fbw">
                “{t.quote}”
              </blockquote>
              <figcaption className="mt-6 flex items-center gap-4 border-t border-navy-900/10 pt-5" data-id="element-313" data-mp="1isdc52fgyi5r">
                <img src={t.photo} alt={t.name} className="h-16 w-16 shrink-0 rounded-full object-cover ring-2 ring-accent-500" loading="lazy" data-id="element-314" data-mp="1erbbqi9tg027" />
                <div data-id="element-315" data-mp="22hxje8fwribo">
                  <p className="flex items-center gap-1.5 font-display font-black text-navy-900" data-id="element-316" data-mp="22hdyqjyvifty">
                    {t.name}
                    <BadgeCheckIcon className="h-4 w-4 text-accent-500" aria-label="Verified buyer" data-id="element-317" data-mp="1xlqcacbs00s5" />
                  </p>
                  <p className="text-sm text-ink/65" data-id="element-318" data-mp="m4gtzt4dvesf">{t.role}</p>
                  <p className="text-sm text-ink/50" data-id="element-319" data-mp="m35o9nrdnwyo">{t.location}</p>
                </div>
              </figcaption>
            </figure>)}
        </div>

        <SectionCTA label="Join these clinicians today" data-id="element-320" data-mp="skz58jgwfuqc" />
      </div>
    </section>;
}